import React, { useState, useEffect } from 'react';
import { GlobalStyles } from '../styles/GlobalStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useTheme } from '../theme';
import LayoutContext from '../hooks/LayoutContext';
import { getDeviceType } from '../utils/helperFunctions';
import { checkUpdatePosts } from '../database/post';
import { useStaticQuery, graphql } from 'gatsby';

const App = ({ children }) => {
  const { theme } = useTheme();
  const { blogs } = useStaticQuery(query);
  const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
  const [openLanguageDialog, setOpenLanguageDialog] = useState(false);
  const [openThemeDialog, setOpenThemeDialog] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [openLeftDrawer, setOpenLeftDrawer] = useState(
    getDeviceType() === 'desktop' ? true : false
  );
  const [openRightDrawer, setOpenRightDrawer] = useState(
    getDeviceType() === 'desktop' ? true : false
  );

  useEffect(() => {
    if (blogs.totalCount && blogs.nodes) {
      checkUpdatePosts(blogs.totalCount, blogs.nodes);
    }
  }, []);

  const handleCloseSettingsDialog = () => {
    setOpenSettingsDialog(false);
    setOpenLanguageDialog(false);
    setOpenThemeDialog(false);
  };

  const values = {
    openLeftDrawer,
    setOpenLeftDrawer,
    openRightDrawer,
    setOpenRightDrawer,
    openSettingsDialog,
    setOpenSettingsDialog,
    openLanguageDialog,
    setOpenLanguageDialog,
    openThemeDialog,
    setOpenThemeDialog,
    openSearch,
    setOpenSearch,
    handleCloseSettingsDialog,
  };

  return (
    <LayoutContext.Provider value={values}>
      <GlobalStyles theme={theme} />
      <CssBaseline />
      {children}
    </LayoutContext.Provider>
  );
};

const query = graphql`
  query {
    blogs: allContentfulBlogPost {
      totalCount
      nodes {
        contentful_id
        title_en
        title_vi
        category
        first_child_category
        second_child_category
        seo_description
        tags
        author
        slug
        description_en
        description_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        author
        updatedAt
        createdAt
      }
    }
  }
`;

export default App;
